var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader__circle-container",style:(("\n      --width: " + _vm.width + ";\n      --height: " + _vm.height + ";\n    "))})])}
var staticRenderFns = []

export { render, staticRenderFns }